module.exports = __webpack_public_path__ + "static/media/SI.15de825c.svg";